import axios from "axios"
import axiosInstance from './interceptorService';

export const getTrainingHubData = () => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/trainingHubFetch`;
    return axiosInstance.get(url, {withCredentials: true})
}
